import { Outlet } from 'react-router-dom';
import {
  Copilot,
  useUserTimeTracking,
  api,
  VisibilityContext, AppDataContext,
} from '@iblai/ibl-web-react-common';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import './DashboardView.css';
import { useContext, useEffect, useState } from 'react';
import useIframeMessage from '../../hooks/useIframeMessage';
import { getTenantMetaData } from '../../hooks/utils/tenant';
const SHOW_MENTOR = process.env.REACT_APP_IBL_ENABLE_MENTOR === 'true';

const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

const DashboardView = () => {
  const { visibilityData } = useContext(VisibilityContext);
  const {setTenantMetaData} = useContext(AppDataContext)
  const [mentorDisplayEnabled,setMentorDisplayEnabled] = useState(false);
  useIframeMessage();
  useUserTimeTracking(api);

  useEffect(() => {
    getTenantMetaData((data)=>{
      setTenantMetaData(data?.metadata ?? {});
      if(SHOW_MENTOR){
        setMentorDisplayEnabled(data?.metadata?.enable_sidebar_ai_mentor_display !== false)
      }
    })
  }, []);

  return (
    <span>
      <span className={`af-view ${!mentorDisplayEnabled ? "use-full-width" : ""}`}>
        <div className="body">
          <div className="full">
            <div
              className={`main-content ${inIframe() ? '' : 'not-in-iframe'}`}
              style={{
                ...(mentorDisplayEnabled ? {} : { paddingRight: 'unset' }),
                ...(inIframe()
                  ? { marginRight: '0px', paddingRight: '0px' }
                  : {}),
              }}
            >
              <div className="div-block-326">
                {!inIframe() && visibilityData.showHeader && <Header></Header>}
                {/*{!inIframe() && <MobileHeader></MobileHeader>}*/}
                <Outlet />
                {!inIframe() && <Footer></Footer>}
              </div>
              {/*<CopilotLauncher />*/}
            </div>
            {!inIframe() && mentorDisplayEnabled && <Copilot />}
            {/*<CopilotCloser />*/}
          </div>
          {/*<CopilotLauncher />*/}
        </div>
      </span>
    </span>
  );
};

export default DashboardView;
